<template>
  <div>
    <div class="be-content" v-if="ticket">
      <div class="main-content container-fluid">
        <div class="page-head">
          <router-link :to="{name: 'support'}">
            <button class="btn pull-right" style="margin-bottom: 10px">
              <i class="icon icon-left mdi mdi-long-arrow-left"></i>
              Вернуться к списку обращений
            </button>
          </router-link>
          <h2 class="page-head-title">Тема: {{ticket.subject}}</h2>
        </div>
        <div class="row">
          <div class="col-md-12">
            <ul class="timeline" style="max-width: none">
              <li class="timeline-item">
                <div class="timeline-date">
                  <span>{{ticket.created_at | dateFilter("DD.MM.YYYY")}}</span>
                </div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <span class="timeline-time">{{ticket.created_at | dateFilter("HH:mm")}}</span>
                    <span class="timeline-autor">{{ticket.created_by}}</span>
                    <div class="timeline-summary">
                      <p>{{ticket.text}}</p>
                      <p v-if="ticket.filepath">Приложение:
                        <a :href="/media/+ticket.filepath">
                          <i class="mdi mdi-attachment-alt"></i>{{ticket.filepath.toString().split('/').slice(-1)[0]}}
                        </a>
                        <br>
                        <a :href="/media/+ticket.filepath">
                          <img :src="/media/+ticket.filepath" alt="Приложение"
                               style="max-width: 300px; max-height: 300px"
                               v-if="ticket.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='jpg' ||
                                  ticket.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='jpeg' ||
                                  ticket.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='gif' ||
                                  ticket.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='png'">
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item" v-for="comment, index in ticket.comments">
                <div class="timeline-date"><span>{{comment.created_at | dateFilter("DD.MM.YYYY")}}</span></div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <span class="timeline-time">{{comment.created_at | dateFilter("HH:mm")}}</span>
                    <span class="timeline-autor">
                      <template v-if="comment.is_operator==='True'">Оператор службы поддержки</template>
                      <template v-if="comment.is_operator==='False'">{{comment.created_by}}</template>
                    </span>
                    <div class="timeline-summary">
                      <p>{{comment.message}}</p>
                      <p v-if="comment.filepath">
                        <a :href="/media/+comment.filepath">
                          <i class="mdi mdi-attachment-alt"></i>{{comment.filepath.toString().split('/').slice(-1)[0]}}
                        </a>
                        <br>
                        <a :href="/media/+comment.filepath">
                          <img :src="/media/+comment.filepath" alt="Приложение"
                               style="max-width: 300px; max-height: 300px"
                               v-if="comment.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='jpg' ||
                                  comment.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='jpeg' ||
                                  comment.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='gif' ||
                                  comment.filepath.toString().split('.').slice(-1)[0].toLowerCase() =='png'">
                        </a>
                      </p>
                    </div>
                    <div v-if="index+1===ticket.comments.length & comment.created_by===$auth.user().username"
                         @click="deleteComment(comment.id)" style="cursor: pointer">
                      <span class="icon mdi mdi-delete pull-right"></span>
                    </div>

                  </div>
                </div>
              </li>
              <div class="form-group" style="margin-left: 154px; margin-right: -15px">
                <div class="col-sm-12">
                  <div class="input-group xs-mb-15" style="margin-bottom: 0px !important;">
                    <input @keyup.enter="sendComment" type="text" class="form-control" placeholder="Сообщение..."
                           v-model="newMessage">
                    <span class="input-group-btn">
                      <button type="button" :class="{disabled: !newMessage & !file}" class="btn btn-primary"
                              @click="sendComment">Отправить</button>
                      </span>
                  </div>
                  <form enctype="multipart/form-data">
                    <button onclick="javascript:document.getElementById('file').click()" type="button"
                            class="btn btn-default">
                      <span><i class="mdi mdi-attachment-alt"></i>
                        <span v-if="!file">Приложить файл...</span>
                        <span v-if="file"> {{file.name}}</span>
                      </span>

                    </button>
                    <span v-if="file" @click="file=null" style="cursor: pointer"><i class="mdi mdi-close"></i></span>
                    <input type="file" style="visibility: hidden" id="file" ref="file"
                           v-on:change="handleFileUpload()"/>
                  </form>

                </div>
              </div>
              <div v-if="sendingMessage" class="col-lg-12">
                <vue-simple-spinner :font-size="20" message="Идёт отправка сообщения."></vue-simple-spinner>
              </div>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    props: ['ticketId'],
    data: function () {
      return {
        ticket: null,
        newMessage: null,
        file: null,
        sendingMessage: false
      }
    },
    created () {
      this.getTicket()
    },
    methods: {
      getTicket () {
        let self = this
        axios.get('/api/tickets/' + this.ticketId + '/').then(function (response) {
          self.ticket = response.data
        }).catch(function (error) {
        })
      },
      sendComment () {
        let formData = new FormData()
        if (this.file) {
          formData.append('file', this.file)
        }
        formData.append('ticket', this.ticket.id)
        if (this.newMessage) {
          formData.append('message', this.newMessage)
        }
        this.sendingMessage = true
        axios.post('/api/comments/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response.status === 201) {
            this.getTicket()
            this.newMessage = null
            this.file = null
          }
          this.sendingMessage = false
        }).catch((error) => {
          if (error.response.status >= 400) {
            this.$snotify.error(error.response.data.detail, 'Ошибка!', {timeout: 10000})
          }
          this.sendingMessage = false
        })
      },
      deleteComment (id) {
        if (window.confirm("Удалить сообщение?")) {
          this.axios.delete('/api/comments/' + id + '/')
            .then((response) => {
              this.$snotify.success('Сообщение удалено.', 'Успешно!')
              this.getTicket()
            }).catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error('При удалении сообщения произошла ошибка!')
            }
          })
        }
      },
      handleFileUpload () {
        this.file = this.$refs.file.files[0]
      },
    }
  }
</script>
<style lang="scss">
  .timeline-summary {
    color: #000000;
    font-size: 14px;
  }

  .timeline-autor {
    color: grey;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/support/TicketComments.vue